<template>
  <v-container fluid class="paystatement-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-paystatement`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Pay Statement
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab
            v-if="isTrade"
            :href="`#tab-trade`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-text-box-check-outline</v-icon>
            Trade Terms
          </v-tab>
          <v-tab-item
            :value="'tab-paystatement'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Pay Statement</p>
                        <v-select
                          class="mb-4"
                          :items=paystatementtype
                          v-model="initial_value.paystatementtype"
                          v-on:change="updateChangedValue($event, 'paystatementtype')"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the sales order type">
                        </v-select>
                        <v-menu
                          ref="menu_paystatementdate"
                          v-model="menu_paystatementdate"
                          :close-on-content-click="false"
                          :return-value.sync="paystatementdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="paystatementdate"
                              label="Pay Statement Date"
                              v-bind="attrs"
                              v-bind:value="paystatementdate"
                              v-on:change="updateChangedValue($event, 'paystatementdate')"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Enter pay statement date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="paystatementdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(paystatementdate, 'paystatementdate'); $refs.menu_paystatementdate.save(paystatementdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-switch
                          v-model="initial_value.paystatementstatus"
                          v-on:change="updateChangedValue($event, 'paystatementstatus')"
                          color="primary"
                          v-bind:label="initial_value.paystatementstatus"
                          value="Active"
                        ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          readonly
                          class="mb-4"
                          :items="employees.map(x => {
                            return {text: x.employeename, value: x._id};
                            })"
                          v-model="initial_value.employeeid"
                          v-bind:error="errorindex == 2"
                          v-on:change="populateEmployeeFields; updateChangedValue($event, 'employeeid')"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line hint="Please choose the employee">
                        </v-select>                        
                        <v-text-field
                          outlined
                          dense
                          class="mb-4"
                          v-model="initial_value.paystatementname"
                          v-on:change="updateChangedValue($event, 'paystatementname')"
                          v-bind:error="errorindex == 10"
                          placeholder="Employee Name"
                          persistent-hint
                          single-line hint="Enter the Employee Name">
                        </v-text-field>
                        <v-textarea
                          outlined
                          v-model="initial_value.paystatementaddress"
                          v-on:change="updateChangedValue($event, 'paystatementaddress')"
                          rows=2
                          label="Address"
                          hint="please enter the employee address"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="townships.map(x => {
                            return {text: x.townshipname, value: x._id};
                            })"
                          v-model="initial_value.townshipid"
                          v-on:change="updateChangedValue($event, 'townshipid')"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Township"
                          persistent-hint
                          single-line hint="Please choose the township">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.paystatementphone"
                          v-on:change="updateChangedValue($event, 'paystatementphone')"
                          outlined
                          v-bind:error="errorindex == 11"
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.paystatementmobile"
                          v-on:change="updateChangedValue($event, 'paystatementmobile')"
                          v-bind:error="errorindex == 12"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the mobile phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_paystatementenddate"
                          v-model="menu_paystatementenddate"
                          :close-on-content-click="false"
                          :return-value.sync="paystatementenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="paystatementenddate"
                              label="Pay Statement Date"
                              v-bind="attrs"
                              v-bind:value="paystatementenddate"
                              v-on:change="updateChangedValue($event, 'paystatementenddate')"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Enter pay statement date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="paystatementenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(paystatementenddate, 'paystatementenddate'); $refs.menu_paystatementenddate.save(paystatementenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.paymethod"
                          v-on:change="updateChangedValue($event, 'paymethod')"
                          outlined
                          dense
                          placeholder="Payment Method"
                          persistent-hint
                          single-line hint="Enter the payment method">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.paystatementnote"
                          v-on:change="updateChangedValue($event, 'paystatementnote')"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">  
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/paystatement/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editItem()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>     
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-details'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="12">
                      <p class="text-h5">Items</p>
                      <v-form>
                        <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="brands.map(x => {
                              return {text: x.brandname, value: x._id};
                              })"
                            v-model="brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line hint="Brand">
                          </v-select>
                        </v-col>
                        <v-col md="4">
                        <v-select
                          class="mb-4"
                          :items=branditems
                          v-model="itemid"
                          v-bind:error="errorindex == 0"
                          v-on:change="populatePriceField"
                          outlined
                          dense
                          placeholder="Item"
                          persistent-hint
                          single-line hint="Item">
                        </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 1) this.value = 1;"
                            single-line hint="Quantity">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="itemprice"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line hint="Price">
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            readonly
                            v-model="itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line hint="Amount">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addTransaction()">
                            Add
                          </v-btn>
                        </v-col>
                      </v-row>
                          <v-data-table
                            :headers="headers"
                            :items="transactions"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                          


                          <template v-slot:top>
                            <v-dialog
                              v-model="dialog"
                              width="500"
                            >
                              <v-card>
                                <v-card-title>
                                  Delete this Item?
                                </v-card-title>
                                <v-card-text>
                                  {{ deletetransaction.itemname }} 
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                                  <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletetransaction)">Delete</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </template>
                            <template v-slot:item.itemimage="{ item }"> 
                              <v-img
                                v-bind:lazy-src="item.itemimage"
                                min-width=50
                                max-width=100
                                v-bind:src="item.itemimage"
                              ></v-img>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="loadTransaction(item)">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn icon color="primary" @click="deleteDialog(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <template slot="body.append">
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th>Subtotal</th>
                                  <th>{{ paystatement.paystatementsubtotal }}</th>
                                  <th></th>
                              </tr>
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th>Total</th>
                                  <th>{{ paystatement.paystatementsubtotal }}</th>
                                  <th></th>
                              </tr>
                            </template>
                          </v-data-table>
                      </v-form>
                    </v-col>
                  </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                          <v-btn
                            to="/paystatement/list"
                            replace
                            outlined
                            color="primary"
                          >
                            Done
                          </v-btn>
                        <v-spacer></v-spacer>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            v-if="isTrade"
            :value="'tab-trade'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Trade Terms</p>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.trade.refnum"
                          v-on:change="updateTradeValue($event, 'refnum')"
                          outlined
                          dense
                          placeholder="Reference Number"
                          persistent-hint
                          single-line hint="Enter reference number">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="incoterms"
                          v-model="initial_value.trade.incoterms"
                          v-on:change="updateTradeValue($event, 'incoterms')"
                          outlined
                          dense
                          placeholder="Incoterms"
                          persistent-hint
                          single-line hint="Please enter incoterms">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_etddate"
                          v-model="menu_etddate"
                          :close-on-content-click="false"
                          :return-value.sync="etddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="etddate"
                              label="ETD Date"
                              v-bind="attrs"
                              v-bind:value="etddate"
                              v-on:change="updateTradeValue($event, 'etddate')"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line 
                              persistent-hint
                              hint="Enter ETD date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="etddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_etddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateTradeValue(etddate, 'etddate'); $refs.menu_etddate.save(etddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_etadate"
                          v-model="menu_etadate"
                          :close-on-content-click="false"
                          :return-value.sync="etadate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="etadate"
                              label="ETD Date"
                              v-bind="attrs"
                              v-bind:value="etadate"
                              v-on:change="updateTradeValue($event, 'etadate')"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line 
                              persistent-hint
                              hint="Enter ETD date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="etadate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_etadate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateTradeValue(etadate, 'etadate'); $refs.menu_etadate.save(etadate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>                        
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.trade.portloading"
                          v-on:change="updateTradeValue($event, 'portloading')"
                          outlined
                          dense
                          placeholder="Port of Loading"
                          persistent-hint
                          single-line hint="Enter the loading port">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="initial_value.trade.portdischarge"
                          v-on:change="updateTradeValue($event, 'portdischarge')"
                          outlined
                          dense
                          placeholder="Port of Discharge"
                          persistent-hint
                          single-line hint="Enter the discharge port">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">  
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/paystatement/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editTradeItem()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>     
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
        <v-bottom-sheet
          v-model="sheet"
          inset
        >
          <v-sheet
            class="text-center"
            height="220px"
          >
            <v-btn
              class="mt-6"
              text
              color="error"
              @click="sheet = !sheet"
            >
              close
            </v-btn>
                      <v-row justify="center">
                        <v-col cols="12" md="2">
                          <v-select
                            class="mb-4"
                            :items="brands.map(x => {
                              return {text: x.brandname, value: x._id};
                              })"
                            v-model="brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line hint="Brand">
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                        <v-select
                          class="mb-4"
                          :items=branditems
                          v-model="itemid"
                          v-bind:error="errorindex == 0"
                          v-on:change="populatePriceField"
                          outlined
                          dense
                          placeholder="Item"
                          persistent-hint
                          single-line hint="Item">
                        </v-select>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 1) this.value = 1;"
                            single-line hint="Qty">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="1">
                          <v-text-field
                            readonly
                            v-model="itemprice"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line hint="Price">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            readonly
                            v-model="itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line hint="Amount">
                          </v-text-field>
                        </v-col>
                        </v-row>
                          <v-btn
                            class="button-shadow"
                            color="warning"
                            @click="editTransaction()">
                            Edit
                          </v-btn>
          </v-sheet>
        </v-bottom-sheet>
  </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import axios from 'axios';

export default {
  data () {
    return {
      headers: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Name', value: 'itemname' },
        { text: 'Foc', value: 'itemfoc' },
        { text: 'Qty', value: 'itemquantity' },
        { text: 'Prc', value: 'itemprice' },
        { text: 'Amount', value: 'itemamount' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      access: [],
      accessname: undefined,
      accesspath: undefined,
      accessenabled: undefined,
      detail: {},
      deletetransaction: {},
      trade: {},
      editedIndex: -1,
      editedItem: {
        _id: undefined,
        accessname: undefined,
        accesspath: undefined,
        accessenabled: undefined,
      },
      paystatement: {},
      sheet: false,
      brandid: undefined,
      price: undefined,
      cid: undefined,
      itemimage: undefined,
      itemid: undefined,
      itemname: undefined,
      itemquantity: 1,
      itemfoc: undefined,
      itemprice: undefined,
      itemamount: undefined,
      itemcategoryid: undefined,
      itemsubcategoryid: undefined,
      branditems: [],
      menu_paystatementdate: false,
      menu_paystatementstartdate: false,
      menu_paystatementenddate: false,
      paystatementdate: null,
      paystatementstartdate: null,
      paystatementenddate: null,
      transactions: [],
      date2: null,
      menu1: false,
      menu2: false,
      dialog: false,
      isTrade: false,
      editdialog: false,
      pin: {
        error: false,
        error2: false
      },
      initial_value: {

      },
      imageurl: undefined,
      error: ['Access Name is required', 'Access path is required'],
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Price', ['getPricesRequest']),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('PayStatement', ['updatePayStatementRequest', 'updatePayStatementTrade']),
    ...mapActions('Township', ['getTownshipsRequest']),
    checkError(){
      if(!this.accessname){
        this.errorindex = 0;
        return false;
      }
      if(!this.accesspath){
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    populateEmployeeFields(employeeid){
      console.log(employeeid)
      var employee = this.employees.find(employee=>employee._id == employeeid);
      this.paystatement.paystatementname = employee.employeename;
      this.paystatement.paystatementaddress = employee.employeeaddress;
      this.paystatement.paystatementphone = employee.employeephone;
      this.paystatement.paystatementmobile = employee.employeemobile;
      this.paystatement.townshipid = employee.townshipid;
      this.paystatement.pricelistid = employee.pricelistid;
    },
    populateItems(brandid){
      let items = this.items.filter(item=>item.brandid == brandid);
      this.branditems = items.map(x => {return {text: x.itemname, value: x._id};})
    },
    populatePriceField(itemid){
      console.log(this.initial_value.pricelistid)
      let price = this.prices.find(price=>price.itemid == itemid && price.pricelistid==this.initial_value.pricelistid);
      let item = this.items.find(item=>item._id == itemid);
      console.log(item);
      this.price = price;
      this.itemprice = price.listprice;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
      this.calculateAmount();
    },
    calculateAmount(){
      this.itemamount = this.itemquantity * this.itemprice;
    },
    calculateTotal(){
      this.paystatement.paystatementsubtotal = this.transactions.reduce((a, b) => a + (b['itemamount'] || 0), 0);
      this.paystatement.paystatementtotal = this.paystatement.paystatementsubtotal;
    },
    clearTransaction(){
      this.cid = undefined;
      this.itemid = undefined;
      this.itemimage = undefined;
      this.itemname = undefined;
      this.itemquantity = 1;
      this.itemprice = undefined;    
      this.itemamount = undefined;
      this.itemcategoryid = undefined
      this.itemsubcategoryid = undefined;
    },
    loadTransaction(item){
      console.log("TRANS", item);
      this.cid = item._id;
      this.sheet = !this.sheet;
      this.brandid = this.items.find(x=>x._id==item.itemid)['brandid'];
      this.populateItems(this.brandid);
      this.itemid = item.itemid;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemquantity = item.itemquantity;
      if(this.itemfoc=='foc'){
        this.itemprice = 0
      }
      else {
        this.itemprice = item.itemprice;
      }
    
      this.itemamount = item.itemamount;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
    },
    async editItem() {
      this.paystatement._id = this.initial_value._id;
      await this.updatePayStatementRequest(this.paystatement);
      router.push('/paystatement/list');
    },
    async editTradeItem() {
      this.trade._id = this.initial_value._id;
      await this.updatePayStatementTrade(this.trade);
      router.push('/paystatement/list');
    },
    addTransaction(){
      if(this.itemprice==null || this.itemamount==null){return}
      let data = {
        townshipid: this.initial_value.townshipid,
        regionid: this.townships.find(township=>township._id==this.initial_value.townshipid).regionid,
        employeeid: this.initial_value.employeeid,
        brandid: this.brandid,
        itemid: this.itemid,
        itemimage: this.itemimage,
        itemname: this.itemname,
        itemquantity: this.itemquantity,
        itemfoc: '',
        itemprice: this.itemprice,
        itemamount: this.itemamount,
        itemcategoryid: this.itemcategoryid,
        itemsubcategoryid: this.itemsubcategoryid,
      };
      
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/add/paystatement/transaction/' + this.initvalue._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "post",url: url,headers: headers,data: data})
      .then( (response)=> {
        this.transactions.push(response.data);
        this.calculateTotal();
        this.clearTransaction();
      });

    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletetransaction = {
        _id: item._id,
        itemname: item.itemname,
        itemquantity: item.itemquantity,
      }
    },
    deleteTransaction(payload){
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/paystatement/transaction/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete",url: url,headers: headers})
      .then( (response)=> {
        let index = this.transactions.findIndex(trans => trans._id == response.data._id);
        this.transactions.splice(index, 1);
      });
    },
    editTransaction(){
      if(this.itemprice==null || this.itemamount==null){return}
      let data = {
        cid: this.cid,
        townshipid: this.initial_value.townshipid,
        regionid: this.townships.find(township=>township._id==this.initial_value.townshipid).regionid,
        employeeid: this.initial_value.employeeid,
        brandid: this.brandid,
        itemid: this.itemid,
        itemimage: this.itemimage,
        itemname: this.itemname,
        itemquantity: this.itemquantity,
        itemfoc: this.itemfoc,
        itemprice: this.itemprice,
        itemamount: this.itemamount,
        itemcategoryid: this.itemcategoryid,
        itemsubcategoryid: this.itemsubcategoryid,
      };
      console.log("DATA", data);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/paystatement/transaction/' + data.cid;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: data})
      .then( (response)=> {
        let index = this.transactions.findIndex(trans => trans._id == response.data._id);
        this.transactions.splice(index, 1, response.data);
        this.sheet = !this.sheet;
        this.calculateTotal();
        this.clearTransaction();
      });
    },
    updateChangedValue(value, field){
      this.paystatement[field] = value;
    },
    updateTradeValue(value, field){
      this.trade[field] = value;
    },
    deleteItem(item) {
      this.deleteTransaction({_id: item._id});
      this.dialog = false;
    },
    deleteItemDialog(item) {
      this.dialog = true;
      this.deletetransactionaccess = {
        _id: item._id,
        accessname: item.accessname,
      }
    },
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Employee', ['employees']),
    ...mapState('Item', ['items']),
    ...mapState('Price', ['prices']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('PayStatement', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.initial_value = this.initvalue;
    if(!this.initial_value._id) this.$router.push({ name: 'PayStatementList' });
      if(this.brands.length==0){this.getBrandsRequest()}
    if(this.employees.length==0){this.getEmployeesRequest()}
    if(this.items.length==0){this.getItemsRequest()}
    if(this.prices.length==0){this.getPricesRequest()}
    if(this.pricelists.length==0){this.getPriceListsRequest()}
    if(this.regions.length==0){this.getRegionsRequest()}
    if(this.townships.length==0){this.getTownshipsRequest()}
    
    if(this.initial_value.paystatementdate!==null){
      let date = new Date(this.initial_value.paystatementdate);
      let month = date.getMonth()<9 ? "0" + (date.getMonth()+1).toString() : (date.getMonth()+1).toString();
      this.paystatementdate = date.getFullYear() + "-" + month + "-" + date.getDate();
    }
    if(this.initial_value.paystatementstartdate!==null){
      let date = new Date(this.initial_value.paystatementstartdate);
      let month = date.getMonth()<9 ? "0" + (date.getMonth()+1).toString() : (date.getMonth()+1).toString();
      this.paystatementstartdate = date.getFullYear() + "-" + month + "-" + date.getDate();
    }
    if(this.initial_value.paystatementenddate!==null){
      let date = new Date(this.initial_value.paystatementenddate);
      let month = date.getMonth()<9 ? "0" + (date.getMonth()+1).toString() : (date.getMonth()+1).toString();
      this.paystatementenddate = date.getFullYear() + "-" + month + "-" + date.getDate();
    }
    this.transactions = this.initial_value.transactions;
    this.calculateTotal();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
